import { scrollIntoView } from 'seamless-scroll-polyfill';

const scrollElementIntoView = ref => {
  if (ref && ref.current) {
    scrollIntoView(ref.current, {
      behavior: 'smooth',
    });
  }
};

export default scrollElementIntoView;
